import { render, staticRenderFns } from "./DepositRequired.vue?vue&type=template&id=beb47924&"
import script from "./DepositRequired.vue?vue&type=script&lang=js&"
export * from "./DepositRequired.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('beb47924')) {
      api.createRecord('beb47924', component.options)
    } else {
      api.reload('beb47924', component.options)
    }
    module.hot.accept("./DepositRequired.vue?vue&type=template&id=beb47924&", function () {
      api.rerender('beb47924', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/DepositRequired.vue"
export default component.exports